import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaGoogle, FaChevronRight } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import defaultLogo from '../assets/logo.png';
import { API_BASE, BACKEND_URL } from '../config';
import './Footer.css';

const Footer = () => {
  const [info, setInfo] = useState({
    address: 'Cumhuriyet Mah. 19 Mayıs Cad. No:36/1 İtfaiye Binası, Didim',
    phone: '0546 664 16 02',
    email: 'info@dihiz.com',
  });
  const [social, setSocial] = useState({ facebook: '', twitter: '', instagram: '', google: '' });
  const [logoSrc, setLogoSrc] = useState(defaultLogo);
  const [footer, setFooter] = useState({
    aboutText: 'Dihiz Turizm Organizasyon & Restoran, Didim Belediyesi bünyesinde faaliyet gösteren çok yönlü bir hizmet kuruluşudur.',
    quickLinks: [
      { label: 'Ana Sayfa', url: '/' },
      { label: 'Hakkımızda', url: '/hakkimizda' },
      { label: 'Duyurular', url: '/duyurular' },
      { label: 'Etkinlikler', url: '/etkinlikler' },
      { label: 'İletişim', url: '/iletisim' },
    ],
    businessLinks: [
      { label: 'Dihiz Restoran', url: '#' },
      { label: 'Dihiz Cafe', url: '#' },
      { label: 'Dihiz Organizasyon', url: '#' },
      { label: 'Dihiz Turizm', url: '#' },
    ],
    copyright: '© 2026 Dihiz Turizm Organizasyon & Restoran. Tüm hakları saklıdır.',
    subtitle: 'Didim Belediyesi İştiraki',
  });

  useEffect(() => {
    fetch(`${API_BASE}/contact`)
      .then(r => r.json())
      .then(data => {
        if (data && data.info) setInfo(prev => ({ ...prev, ...data.info }));
        if (data && data.socialLinks) setSocial(data.socialLinks);
      })
      .catch(() => {});

    fetch(`${API_BASE}/footer`)
      .then(r => r.json())
      .then(data => {
        if (data && data._id) setFooter(prev => ({ ...prev, ...data }));
      })
      .catch(() => {});

    fetch(`${API_BASE}/settings`)
      .then(r => r.json())
      .then(data => {
        if (data && data.footerLogo) setLogoSrc(`${BACKEND_URL}${data.footerLogo}`);
      })
      .catch(() => {});
  }, []);

  const renderLink = (item, index) => {
    if (item.url && item.url.startsWith('/')) {
      return (
        <li key={index}>
          <Link to={item.url}><FaChevronRight /> {item.label}</Link>
        </li>
      );
    }
    return (
      <li key={index}>
        <a href={item.url || '#'}><FaChevronRight /> {item.label}</a>
      </li>
    );
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          <div className="footer-grid">
            {/* Logo & Hakkında */}
            <div className="footer-col footer-about">
              <div className="footer-logo">
                <img src={logoSrc} alt="Dihiz" />
              </div>
              <p className="footer-about-text">{footer.aboutText}</p>
              <div className="footer-social">
                {social.facebook && <a href={social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>}
                {social.twitter && <a href={social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaXTwitter /></a>}
                {social.instagram && <a href={social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>}
                {social.google && <a href={social.google} target="_blank" rel="noopener noreferrer" aria-label="Google"><FaGoogle /></a>}
              </div>
            </div>

            {/* Hızlı Linkler */}
            <div className="footer-col">
              <h4 className="footer-col-title">Hızlı Linkler</h4>
              <ul className="footer-links">
                {footer.quickLinks?.map((item, i) => renderLink(item, i))}
              </ul>
            </div>

            {/* İşletmelerimiz */}
            <div className="footer-col">
              <h4 className="footer-col-title">İşletmelerimiz</h4>
              <ul className="footer-links">
                {footer.businessLinks?.map((item, i) => renderLink(item, i))}
              </ul>
            </div>

            {/* İletişim */}
            <div className="footer-col">
              <h4 className="footer-col-title">İletişim</h4>
              <ul className="footer-contact">
                <li>
                  <FaMapMarkerAlt className="footer-contact-icon" />
                  <span>{info.address}</span>
                </li>
                <li>
                  <FaPhone className="footer-contact-icon" />
                  <a href={`tel:${info.phone?.replace(/\s/g, '')}`}>{info.phone}</a>
                </li>
                <li>
                  <MdEmail className="footer-contact-icon" />
                  <a href={`mailto:${info.email}`}>{info.email}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-inner">
            <p>{footer.copyright}</p>
            <p className="footer-bottom-sub">{footer.subtitle}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
